import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const COLORS = ["#2B5339", "#728A7C", "#D4B886"];

export default function AssetAllocationDonut({ allocation }) {
  const data = [
    { name: "Stocks", value: allocation.stocks },
    { name: "Bonds", value: allocation.bonds },
    { name: "Cash", value: allocation.cash },
  ].filter((d) => d.value > 0);

  return (
    <div data-testid="allocation-donut" className="w-full h-full flex flex-col">
      <div className="text-[11px] tracking-[0.2em] uppercase text-[#5C6B62] font-semibold mb-3">
        Asset mix
      </div>
      <div className="flex items-center gap-4 flex-1">
        <div className="w-32 h-32 relative">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                innerRadius={36}
                outerRadius={58}
                paddingAngle={2}
                stroke="none"
                isAnimationActive={false}
              >
                {data.map((entry, i) => (
                  <Cell key={entry.name} fill={COLORS[i]} />
                ))}
              </Pie>
              <Tooltip
                formatter={(v, n) => [`${v}%`, n]}
                contentStyle={{
                  background: "#fff",
                  border: "1px solid #E5E2DC",
                  borderRadius: 12,
                  fontSize: 12,
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <ul className="space-y-2 flex-1">
          {data.map((d, i) => (
            <li key={d.name} className="flex items-center justify-between text-sm">
              <span className="inline-flex items-center gap-2 text-[#1C2B23]">
                <span className="w-2 h-2 rounded-full" style={{ background: COLORS[i] }} /> {d.name}
              </span>
              <span className="font-mono-num text-[#5C6B62]">{d.value}%</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
